<mat-form-field [subscriptSizing]="subscriptSizing" class="full-width-form" color="accent">
	<mat-label>
		<ng-content select="[labelPrefix]" />
		{{ labelToken() | translate }}
	</mat-label>
	<div appStopPropagation class="labelSuffix" matSuffix>
		<ng-content select="[actions]" />
		<button (click)="onSearchButtonClick()" mat-icon-button>
			<mat-icon color="accent" fontIcon="fa-search" fontSet="fad" />
		</button>
	</div>
	<input
		#searchInput
		#trigger="matAutocompleteTrigger"
		[formControl]="inputCtrl"
		[matAutocomplete]="auto"
		[required]="required ?? formCtrl()?.hasValidator(Validators.required)"
		matInput
		placeholder="..."
		type="text"
	/>
	<mat-error>{{ errorToken | translate }}</mat-error>
	<mat-autocomplete #auto="matAutocomplete">
		@if (showSpinner()) {
			<mat-option class="busy" disabled />
		} @else {
			@if (filteredOptions().length) {
				@for (filteredOption of filteredOptions(); track filteredOption.id) {
					<mat-option (onSelectionChange)="handleSelect(filteredOption)" [value]="filteredOption">
						{{ filteredOption.label }}
					</mat-option>
				}
			} @else {
				<mat-option disabled>{{ T.AUTOCOMPLETE_NO_RESULTS | translate }}</mat-option>
			}
		}
	</mat-autocomplete>
</mat-form-field>
